var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1053 15.7762V18.2643C11.0096 17.8833 9.83707 17.7665 8.68602 17.9236C7.53496 18.0806 6.43903 18.507 5.49026 19.1669C4.54149 19.8268 3.76757 20.701 3.23351 21.716C2.69945 22.731 2.42083 23.8572 2.42105 25L3.12868e-07 24.9988C-0.000375401 23.5451 0.337642 22.1106 0.988151 20.8052C1.63866 19.4999 2.5844 18.3583 3.75289 17.4679C4.92139 16.5775 6.28163 15.9621 7.7294 15.6686C9.17716 15.3752 10.674 15.4116 12.1053 15.775V15.7762ZM9.68421 14.2857C5.67132 14.2857 2.42105 11.0893 2.42105 7.14286C2.42105 3.19643 5.67132 0 9.68421 0C13.6971 0 16.9474 3.19643 16.9474 7.14286C16.9474 11.0893 13.6971 14.2857 9.68421 14.2857ZM9.68421 11.9048C12.3595 11.9048 14.5263 9.77381 14.5263 7.14286C14.5263 4.5119 12.3595 2.38095 9.68421 2.38095C7.00895 2.38095 4.84211 4.5119 4.84211 7.14286C4.84211 9.77381 7.00895 11.9048 9.68421 11.9048ZM16.9474 19.0476V15.4762H19.3684V19.0476H23V21.4286H19.3684V25H16.9474V21.4286H13.3158V19.0476H16.9474Z",
    fill: "#0C7488"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6d95cd91f63bc3868501dd1314bab9f4.svg";
export { ForwardRef as ReactComponent };